export default {
    "baseURL": "https://recruitment-test.myxalary.com",
    "baseURLLocal": "http://localhost:3500",
    "signUp": "/v1/jobs/tracker/sign-up",
    "login": "/v1/jobs/tracker/login",
    "logout": "/v1/jobs/tracker/logout",
    "resendConfirmation": "/v1/jobs/tracker/resend-confirmation",
    "confirmAccount": "/v1/jobs/tracker/confirm-account",
    "resetPasswordLink": "/v1/jobs/tracker/reset-password-link",
    "changePassword": "/v1/jobs/tracker/reset-password",
    "profile": "/v1/jobs/tracker/profile",
    "jobList": "/v1/jobs/tracker/job-list",
    "MyjobList": "/v1/jobs/tracker/my-job-list",
    "apply": "/v1/jobs/tracker/job-apply",
    "accept": "/v1/jobs/tracker/job-accept",
    "reject": "/v1/jobs/tracker/job-reject",
    "skills": "/v1/jobs/tracker/job-skills",
    "onboard": "/v1/jobs/tracker/job-onboard",
    "onboarding": "/v1/jobs/tracker/onboarding",
    "locationAPI":"https://www.universal-tutorial.com/api/",
    "getLinkedInUser":"/v1/jobs/tracker/getLinkedInUser"
}